var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Search'),_vm._l((_vm._stocks),function(stock,index){return (stock.product)?_c('EntryStock',{key:index,attrs:{"stock":stock}}):_vm._e()})],2)}
var staticRenderFns = []

export { render, staticRenderFns }